import React from "react";

function EditInput({ title, children }) {
  return (
    <div className="grid items-start gap-1 mb-4 sm:gap-4 sm:grid-cols-[20%,1fr] min-h-[40px]">
      <p className="text-gray-500 mt-2">{title}</p>
      {children}
    </div>
  );
}

export default EditInput;
